import { Factory, trait } from 'miragejs';
import { faker } from '@faker-js/faker';

export default Factory.extend({
  name: () => faker.lorem.word(),
  calendarId: () => faker.internet.email(),
  claimable: () => faker.datatype.boolean(),
  maskMeetingNames: () => faker.datatype.boolean(),
  checkInEnabled: () => faker.datatype.boolean(),
  displayName: () => faker.lorem.word(),
  floor: (i) => (i % 3 ? 'Floor 1' : 'Floor 2'),

  withDevice: trait({
    afterCreate(room, server) {
      server.create('roomba/device', { room });
    },
  }),

  withBuilding: trait({
    afterCreate(room, server) {
      server.create('roomba/building', { rooms: [room] });
    },
  }),
});
